module.exports = __webpack_public_path__ + "img/menu-reward.a3c7be70.svg";